import React, { useEffect, useState } from "react";
import ContentCard from "../../common/template/contentCard";
import Grid from "../../common/layout/grid";
import Button from "../../common/button/button";
import Row from "../../common/layout/row";
import NumberFormat from "react-number-format";
import DateFormat from "../../common/dateFormat/DateFormat";

export function DefinirEnergiaAnoForm(props) {
    const [ano, mes, dia] = String(props.dataGrafico).split("-");
    if (!ano || !mes || !dia) return <div style={{ color: "red" }}>Erro ao exibir formulário para incluir leitura</div>;

    const ultimoDia = DateFormat.obterUltimoDiaFechadoOuAtualDoMes(ano, mes);
    const mesValidado = DateFormat.obterUltimoMesFechadoOuAtualDoAno(ano);
    const formDefault = {
        ano,
        mes: mesValidado,
        dia: ultimoDia,
        data_hora: `${ano}-${mesValidado}-${ultimoDia} 23:59:59`,
        energia_ano_string: "0",
        energia_ano: 0,
        id_geracao_integracao: props.idGeracaoIntegracao,
    };
    const [form, setForm] = useState(formDefault);
    const [exibirForm, setExibirForm] = useState(false);

    useEffect(() => {
        const mesValidado = DateFormat.obterUltimoMesFechadoOuAtualDoAno(ano);
        const ultimoDia = DateFormat.obterUltimoDiaFechadoOuAtualDoMes(ano, mesValidado);
        setForm({
            ...form,
            ano,
            mes: mesValidado,
            dia: ultimoDia,
            data_hora: `${ano}-${mesValidado}-${ultimoDia} 23:59:59`,
        });
    }, [props.dataGrafico]);


    if (!exibirForm) {
        return (
            <ContentCard style={{ width: "100%", padding: 20 }}>
                <Row alignCenter>
                    <Button
                        text="Definir Energia do Ano"
                        type={"primary"}
                        icon={"fas fa-edit"}
                        event={() => {
                            props.callbackOpenForm();
                            setExibirForm(true);
                        }}
                    />
                </Row>
            </ContentCard>
        );
    }

    return (
        <ContentCard style={{ width: "100%", padding: 20 }}>
            <Row alignCenter>
                <Grid cols="12 12 12 12">
                    <label>Energia do Ano ({form.ano})</label>
                    <NumberFormat
                        className="form-control"
                        style={{ height: 40, fontSize: 13, marginBottom:20 }}
                        placeholder={"0"}
                        decimalSeparator={","}
                        decimalScale={2}
                        fixedDecimalScale={2}
                        value={form.energia_ano_string}
                        onValueChange={(values) => {
                            setForm({
                                ...form,
                                energia_ano: values.floatValue,
                                energia_ano_string: values.formattedValue,
                            });
                        }}
                    />
                </Grid>
            </Row>
            <Row alignCenter>
                <Grid cols="6 6 6 6">
                    <Button
                        style={{ margin: 0 }}
                        text="Incluir"
                        type={"success"}
                        icon={"fa fa-check"}
                        event={() => {
                            props.handleSubmit(form);
                            setForm(formDefault);
                            setExibirForm(false);
                            props.callbackCloseForm();
                        }}
                    />
                </Grid>

                <Grid cols="6 6 6 6">
                    <Button
                        style={{ margin: 0 }}
                        text="Cancelar"
                        type={"danger"}
                        icon={"fa fa-times"}
                        event={() => {
                            setForm(formDefault);
                            setExibirForm(false);
                            props.callbackCloseForm();
                        }}
                    />
                </Grid>
            </Row>
        </ContentCard>
    );
}
